import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=3d9c486e"
import script from "./MemberDetails.vue?vue&type=script&lang=ts"
export * from "./MemberDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports